/*
 * Hover/focus/click highlight used by the Benefits spotlight, How to use and
 * Formulation system sections. Each title is (or contains) a disclosure
 * <button> with aria-expanded; its body is the title's next sibling. Inactive
 * bodies are made `inert` so hidden links can't take keyboard focus.
 */
class VrHoneyHighlight extends HTMLElement {
  connectedCallback() {
    this.titles = Array.from(this.querySelectorAll('[data-vr-honey-title]'));
    this.media = Array.from(this.querySelectorAll('[data-vr-honey-media]'));
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.titles.forEach((title, i) => {
      const index = Number(title.dataset.index);
      const trigger = title.matches('button') ? title : title.querySelector('button');
      const body = title.nextElementSibling;

      if (trigger && body) {
        if (!body.id) body.id = `vr-honey-body-${this.id || 'x'}-${i}-${Math.random().toString(36).slice(2, 7)}`;
        trigger.setAttribute('aria-controls', body.id);
      }

      (trigger || title).addEventListener('click', (event) => {
        event.preventDefault();
        this.setActive(index);
      });
      title.addEventListener('mouseenter', () => this.setActive(index));
      (trigger || title).addEventListener('focus', () => this.setActive(index));
    });

    if (this.titles.length) {
      this.setActive(Number(this.titles[0].dataset.index));
    }
  }

  setActive(index) {
    if (this.activeIndex === index) return;
    this.activeIndex = index;

    this.titles.forEach((title) => {
      const isActive = Number(title.dataset.index) === index;
      const trigger = title.matches('button') ? title : title.querySelector('button');
      const body = title.nextElementSibling;
      title.classList.toggle('is-active', isActive);
      trigger?.setAttribute('aria-expanded', `${isActive}`);
      if (body && trigger) body.inert = !isActive;
    });

    this.media.forEach((media) => {
      const isActive = Number(media.dataset.index) === index;
      media.classList.toggle('is-active', isActive);

      const video = media.querySelector('video');
      if (video) {
        if (isActive && !this.reduceMotion.matches && video.dataset.userPaused !== 'true') {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
  }
}

if (!customElements.get('vr-honey-highlight')) {
  customElements.define('vr-honey-highlight', VrHoneyHighlight);
}
